<!--
  First and last name as two boxes, kept as one "First Last" value. Everyone gives both, so two
  people with the same first name are easy to tell apart.
-->
<script lang="ts">
  import { untrack } from "svelte";
  let {
    value = $bindable(""),
    label = "Name",
    firstPlaceholder = "Emily",
    lastPlaceholder = "Chen",
    oninput,
  }: { value?: string; label?: string; firstPlaceholder?: string; lastPlaceholder?: string; oninput?: () => void } = $props();

  let first = $state("");
  let last = $state("");
  /** What these boxes last sent up, so only a change from outside re-splits them. */
  let sent: string | null = null;
  // Split a name set from outside into the two boxes (the first word, then the rest).
  $effect(() => {
    const v = value.trim();
    if (v === sent) return;
    untrack(() => {
      const i = v.indexOf(" ");
      first = i < 0 ? v : v.slice(0, i);
      last = i < 0 ? "" : v.slice(i + 1);
    });
  });
  function sync() {
    sent = `${first.trim()} ${last.trim()}`.trim();
    value = sent;
    oninput?.();
  }
</script>

<div class="full" role="group" aria-label={label}>
  <label class="field"><span>First name</span><input class="input" bind:value={first} oninput={sync} autocomplete="given-name" autocapitalize="words" placeholder={firstPlaceholder} /></label>
  <label class="field"><span>Last name</span><input class="input" bind:value={last} oninput={sync} autocomplete="family-name" autocapitalize="words" placeholder={lastPlaceholder} /></label>
</div>

<style>
  .full {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
</style>
